import { z } from 'zod';
import { macroTriggerSchema } from '../macroTree';
import { sha256HexSchema } from './canonicalJson';

/** Kept independent of package/workflow schemas to prevent eager initialization cycles. */
export const sourceGraphIdentitySchema = z.object({
  campaignId: z.string().min(1).max(128), trigger: macroTriggerSchema,
  variant: z.literal('source-graph'), rev: z.number().int().positive().safe(),
  graphDigest: sha256HexSchema, bindingsDigest: sha256HexSchema,
}).strict();
export type SourceGraphIdentity = z.infer<typeof sourceGraphIdentitySchema>;
